import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-choose-library-category',
    templateUrl: './choose-library-category.component.html',
    styleUrls: ['./choose-library-category.component.scss'],
    standalone: false
})
export class ChooseLibraryCategoryComponent implements OnInit {
  categories: any[] = [];
  selectedCategory: any;

  constructor(
    public dialogRef: MatDialogRef<ChooseLibraryCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.categories = data.categories;
  }

  public handleSelectionChange() {
    this.dialogRef.close(this.selectedCategory);
  }

  ngOnInit(): void {
    if (this.data && this.data.categories) {
      this.categories = this.data.categories;
      console.log('this.data.categories: ', this.data.categories);
    }
  }
}
